module.exports = __webpack_public_path__ + "assets/img/foone.2e3daa41.png";